import api from '@/api'

export interface SmtTranRequest{
    date_client_req:Date,
    content:string,
    callback:string,
    recipient_num:Array<string>
}

export default {

    sendSms(req:SmtTranRequest): Promise<number> {
        return api.post({
            url: `/api/HK/Sms/send`,
            data: req
        })
    }
}